import React from 'react';
import './PaymentModal.css';

const PaymentModal = ({ isOpen, onClose, onPaymentSelect, total, currencySymbol }) => {
  if (!isOpen) return null;

  const handlePaymentMethod = (method) => {
    onPaymentSelect(method);
  };

  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div className="payment-modal-content" onClick={e => e.stopPropagation()}>
        <div className="payment-modal-header">
          <h3>Select Payment Method</h3>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="payment-total">
          <span>Total Amount: </span>
          <strong>{currencySymbol}{total.toFixed(2)}</strong>
        </div>

        <div className="payment-methods">
          <button 
            className="payment-method-btn cash-btn"
            onClick={() => handlePaymentMethod('cash')}
          >
            <div className="payment-icon">
              <i className="fas fa-money-bill-wave"></i>
            </div>
            <div className="payment-text">
              <span className="method-name">Cash Payment</span>
              <span className="method-desc">Pay with cash</span>
            </div>
          </button>

          <button 
            className="payment-method-btn razorpay-btn"
            onClick={() => handlePaymentMethod('razorpay')}
          >
            <div className="payment-icon">
              <i className="fas fa-credit-card"></i>
            </div>
            <div className="payment-text">
              <span className="method-name">Card/Online</span>
              <span className="method-desc">Pay via RazorPay</span>
            </div>
          </button>

          <button 
            className="payment-method-btn touchngo-btn"
            onClick={() => handlePaymentMethod('touchngo')}
          >
            <div className="payment-icon">
              <i className="fas fa-qrcode"></i>
            </div>
            <div className="payment-text">
              <span className="method-name">Touch 'n Go</span>
              <span className="method-desc">Scan QR with TNG eWallet</span>
            </div>
          </button>
        </div>

        <div className="payment-modal-footer">
          <button className="cancel-payment-btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;